/**
 * Extracts the first string value from a ParsedQs value.
 * If the value is an array, returns the first element.
 * If the value is a nested ParsedQs object, recursively extracts the first string.
 */
export const getFirstStringValue = (
  value: string | string[] | qs.ParsedQs | qs.ParsedQs[] | undefined
): string => {
  if (value === undefined || value === null) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? getFirstStringValue(value[0]) : "";
  }

  // Handle nested ParsedQs object by taking the first available value
  if (typeof value === "object") {
    const firstKey = Object.keys(value)[0];
    return firstKey ? getFirstStringValue(value[firstKey]) : "";
  }

  return "";
};
